module.exports = __webpack_public_path__ + "static/media/Deals.fe7d7bf4.svg";